import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  AppState,
  FramesActionTypes,
  FramesCartActionTypes,
  selectPatientId,
  selectRelatedFrames,
  selectProfile
} from '@app/core/ngrx';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService, SearchService, UserService } from '@app/core/services';
import { OrderService } from '@app/core/services/order.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { environment } from '@env/environment';
import { User } from '@app/core/models';
import { State } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import { AddToCartNotificationsComponent, AlertDialogComponent, ConfirmDialogComponent } from '@app/shared/components';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { StateCodeData } from '../state-code.data';
import { AddressModalComponent } from '../address-modal/address-modal.component';

@Component({
  selector: 'ecp-frame-details',
  templateUrl: './frame-details.component.html',
  styleUrls: ['./frame-details.component.scss'],
})
export class FrameDetailsComponent implements OnInit, OnDestroy {
  @Input() user: User;
  // @select('frameDetails')
  frame$: Observable<any>;
  form: FormGroup;
  selectedFrameUpc: string;
  rxIdVBAPattern = [Validators.required, Validators.pattern(/^[0-9]{10}$/)];
  rxIdUHCPattern = [Validators.required, Validators.pattern(/^(V[0-9a-zA-Z]{13})$/i)];
  rxIdVSPPattern = [
    Validators.required,
    Validators.pattern(
      /^(?!0{6})([0-9]{7}[1-9]|[0-9]{6}[1-9][0-9]|[0-9]{5}[1-9][0-9]{2}|[0-9]{4}[1-9][0-9]{3}|[0-9]{3}[1-9][0-9]{4}|[0-9]{2}[1-9][0-9]{5}|[0-9][1-9][0-9]{6}|[1-9][0-9]{7})$/i,
    ),
  ];
  rxIdVWPattern = [
    Validators.required,
    Validators.pattern(
      /^(?!0{6})(SP[A-Za-z0-9]{5}[A-Za-z1-9]|SP[A-Za-z0-9]{4}[A-Za-z1-9][A-Za-z0-9]|SP[A-Za-z0-9]{3}[A-Za-z1-9][A-Za-z0-9]{2}|SP[A-Za-z0-9]{2}[A-Za-z1-9][A-Za-z0-9]{3}|SP[A-Za-z0-9]{1}[A-Za-z1-9][A-Za-z0-9]{4}|SP[A-Za-z1-9][A-Za-z0-9]{5}|Z[0-9]{8})$/i,
    ),
  ];

  upc;
  frame: any = null;
  manageCareLabList: any = [];
  frameSize: any = [];
  RBAMessage;
  relatedFrames$: Observable<any>;
  isMeta: boolean = false;
  isNuance: boolean = false;
  ordered = false;
  loaded = true;
  hideName = false;
  is360Available = false;
  isVBA: boolean;
  patientId;
  patientId$: Observable<any>;
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  patientAddressBlock: boolean = true;
  showAddressToggle: boolean = false;
  stateCodes: any = StateCodeData;
  orderFrameLoading:boolean = false;
  isViewOnly:boolean = false;
  orderability:any = '0';
  isOutOfStock:boolean = false;
  constructor(
    private _ngZone: NgZone,
    private fb: FormBuilder,
    private state: State<AppState>,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private searchService: SearchService,
    private userService: UserService,
    private orderService: OrderService,
    private router: Router,
    public dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
    this.patientId$ = this.store.pipe(select(selectPatientId));
    this.relatedFrames$ = this.store.pipe(select(selectRelatedFrames));
    this.frame$ = this.store.pipe(select(myState => myState.frameDetails));
    let userProfile = this.store.pipe(select(selectProfile));
    userProfile.subscribe((res:any)=>{
      if(res?.ecpRole.toLowerCase() === "viewonly"){
        this.isViewOnly = true;
      }else{
        this.isViewOnly = false;
      }
    })
    this.activatedRoute.params.subscribe(param => {
      this.upc = param.upc;
      this.patientId = param.id ? param.id : this.patientId;
      let frameList = this.state.getValue().frames.list.frames;
      if (frameList.length === 0) {
        if (this.patientId) {
          this.store.dispatch({
            type: FramesActionTypes.LOAD_PATIENT_FRAME_DETAILS,
            payload: {
              filters: {
                terms: [param.upc],
                brands: [],
                sizes: [],
                skip: 0,
              },
              id: this.patientId,
            },
          });
        } else {
          this.store.dispatch({
            type: FramesActionTypes.LOAD_FRAME_DETAILS,
            payload: {
              terms: [param.upc],
              brands: [],
              sizes: [],
              skip: 0,
            },
          });
        }
      } else {
        this.store.dispatch({
          type: FramesActionTypes.LOAD_FRAME_DETAILS_SUCCESS,
          payload: frameList.filter(f => f.upc === param.upc)[0],
        });
      }
    });

    this.patientId$.subscribe(patientId => {
      this.patientId = patientId;
    });
    this.relatedFrames$.subscribe(frames => {
      if (frames.length >= 1) {
        this.frameSize = [];
        frames.forEach(element => {
          if (!this.frameSize.includes(element.eyeSize)) {
            this.frameSize.push(element.eyeSize);
            if (this.frame.eyeSize) {
              this.eyeSize.setValue(this.frame.eyeSize);
            }
            this.check360(this.frame.upc);
          }
        });
      }
    });

    if (this.frame) {
      this.check360(this.frame.upc);
    }

    this.frame$.subscribe(frame => {
      if (frame && frame.loaded) {
        this.frame = frame.frame;
        this.getRelatedFrames(this.frame);
      }
    });
  }
  /**
   * ngOnInit
   * @description
   */
  ngOnInit(): void {
    if (!this.patientId) {
      this.userService.getDropship().subscribe(dropShip => {
        this.manageCareLabList = dropShip;
      });

      // this.orderService.getRBAMessage(this.frame.upc).subscribe(message => {
      //   this.RBAMessage = message;
      // });
    }
  }
  get eyeSize(): AbstractControl {
    return this.form.get('eyeSize');
  }

  get displayBoard(): AbstractControl {
    return this.form.get('displayBoard');
  }

  get addFrameTo(): AbstractControl {
    return this.form.get('addFrameTo');
  }

  get sendFrameTo(): AbstractControl {
    return this.form.get('sendFrameTo');
  }

  get manageCareLab(): AbstractControl {
    return this.form.get('manageCareLab');
  }

  get laboratory(): AbstractControl {
    return this.form.get('laboratory');
  }

  get provider(): AbstractControl {
    return this.form.get('provider');
  }

  get firstName(): AbstractControl {
    return this.form.get('firstName');
  }

  get lastName(): AbstractControl {
    return this.form.get('lastName');
  }

  get rxOrderId(): AbstractControl {
    return this.form.get('rxOrderId');
  }

  createForm(): FormGroup {
    return this.fb.group({
      eyeSize: [''],
      displayBoard: [false],
      sendFrameTo: [
        this.frame.inStock === true ||
        (this.frame.exceptionType !== 'OUT_OF_STOCK' && this.frame.exceptionType !== 'SHORT_SHIP')
          ? 'Lab'
          : 'My Office',
      ],
      addFrameTo: ['false'],
      manageCareLab: [''],
      laboratory: ['primary'],
      firstName: [
        '',
        Validators.compose([Validators.required, this.noWhitespaceValidator, Validators.pattern('^[A-Za-z0-9 ]+$')]),
      ],
      lastName: [
        '',
        Validators.compose([Validators.required, this.noWhitespaceValidator, Validators.pattern('^[A-Za-z0-9 ]+$')]),
      ],
      rxOrderId: [
        '',
        this.frame.inStock === true ||
        (this.frame.exceptionType !== 'OUT_OF_STOCK' && this.frame.exceptionType !== 'SHORT_SHIP')
          ? this.rxIdVWPattern
          : '',
      ],
      provider: [''],
    });
  }
  onChangeName(type: any, ev: any) {
    if (this.showAddressToggle) {
      this.form.controls[`_${type}`].setValue(ev.target.value);
    } else {
      return false;
    }
  }
  frameOutOfStock(frame){
    if(frame.exceptionType === "OUT_OF_STOCK"){
      this.isOutOfStock = true;
      this.sendFrameTo.patchValue('My Office');
      this.sendFrameTo.updateValueAndValidity();
    }
  }
  showPatient(ev: MatCheckboxChange = null) {
    if (this.showAddressToggle) {
      this.form.addControl('_firstName', new FormControl(this.firstName.value));
      this.form.addControl('_lastName', new FormControl(this.lastName.value));
      this.form.addControl('_number', new FormControl('', [Validators.required,Validators.pattern(/^[0-9]\d*$/)]));
      this.form.addControl('_unit', new FormControl(''));
      this.form.addControl('_street', new FormControl('', Validators.required));
      this.form.addControl('_city', new FormControl('', Validators.required));
      this.form.addControl('_state', new FormControl('', Validators.required));
      this.form.addControl('_zip', new FormControl('', Validators.required));
    } else {
      this.form.removeControl('_firstName');
      this.form.removeControl('_lastName');
      this.form.removeControl('_number');
      this.form.removeControl('_unit');
      this.form.removeControl('_street');
      this.form.removeControl('_city');
      this.form.removeControl('_state');
      this.form.removeControl('_zip');
    }
  }
  isDtpEnabled() {
    let isEnabled = this.manageCareLabList.primary?.isDtpEnabled;
    if (this.sendFrameTo.value !== 'Lab') {
      return this.manageCareLabList.office.isDtpEnabled;
    } else {
      if (this.form.value.laboratory !== 'primary') {
        isEnabled = this.form.value.manageCareLab?.isDtpEnabled;
      }
    }
    return isEnabled;
  }
  onSubmit(ev): boolean {
    this.loading$.next(true);
    this.ordered = true;
    if (this.form.valid) {
      let payload = null;
      switch (this.form.value.sendFrameTo) {
        case 'Lab':
          if (this.form.value.laboratory === 'primary') {
            payload = {
              fpc: this.frame.fpc,
              facId: this.manageCareLabList.primary.frameAccountId,
              orderType: this.manageCareLabList.primary.dropshipType,
              patientFirstName: this.form.value.firstName,
              patientLastName: this.form.value.lastName,
              rxOrderId: this.form.value.rxOrderId,
              isDirectToPatient: false,
            };
          } else {
            payload = {
              fpc: this.frame.fpc,
              facId: this.form.value.manageCareLab.frameAccountId,
              orderType: this.form.value.manageCareLab.dropshipType,
              patientFirstName: this.form.value.firstName,
              patientLastName: this.form.value.lastName,
              rxOrderId: this.form.value.rxOrderId,
              isDirectToPatient: false,
            };
          }
          break;
        default:
          if (this.form.value.displayBoard) {
            payload = {
              fpc: this.frame.fpc,
              facId: this.manageCareLabList.office.frameAccountId,
              orderType: 'FOR_BOARD',
              addToMyPicks: this.addFrameTo.value,
              patientFirstName: this.form.value.firstName,
              patientLastName: this.form.value.lastName,
              isDirectToPatient: false,
            };
          } else {
            payload = {
              fpc: this.frame.fpc,
              facId: this.manageCareLabList.office.frameAccountId,
              orderType: 'OFFICE',
              addToMyPicks: false,
              patientFirstName: this.form.value.firstName,
              patientLastName: this.form.value.lastName,
              isDirectToPatient: false,
            };
          }
          break;
      }
      if (this.isDtpEnabled() == true && this.showAddressToggle == true) {
        // Validate Address
        payload.isDirectToPatient = true;
        payload.firstName = this.form.value._firstName;
        payload.lastName = this.form.value._lastName;

        let addressPayload = {
          ...payload,
          addressInformation: {
            unit: this.form.value._unit,
            number: this.form.value._number,
            street: this.form.value._street,
            city: this.form.value._city,
            stateCode: this.form.value._state,
            postalCode: this.form.value._zip,
            countryCode: 'US',
          },
        };
        this.validateAddress(addressPayload);
      } else {
        //console.log('DTP => FALSE, ORDER =>', payload);
        this.confirmOrder(payload);
      }
    }
    return false;
  }
  validateAddress(order: any) {
    //VALIDATE ADDRESS SERVICE API
    let addressInfo = order.addressInformation;
    this.orderFrameLoading = true;
    this.orderService.orderAddressValidation(addressInfo).subscribe(
      res => {
        this.orderFrameLoading = false;
        let validOrder = res;
        let dialogRef = this.dialog
          .open(AddressModalComponent, {
            width: '750px',
            maxWidth: '99.3vw',
            maxHeight: '82vh',
            disableClose: true,
            data: {
              title: 'Validated Address',
              content: `${validOrder?.formattedAddress}`,
              cancelBtnText: 'Cancel',
              enteredBtnText: 'Use Entered Address',
              validateBtnText: 'Use Validated Address',
              isValid: validOrder?.validAddress
            },
          })
          .afterClosed()
          .subscribe(async resp => {
            if(resp === 'entered'){
              this.confirmOrder(order)
            }else if(resp === 'validated'){
              order.addressInformation = validOrder;
              this.confirmOrder(order)
            }else{
              //console.log(order);
            }
            this.ordered = false;
          });
      },
      () => {
        this.ordered = false;
        this.dialog
          .open(ConfirmDialogComponent, {
            width: '600px',
            maxWidth: '89.3vw',
            maxHeight: '82vh',
            data: {
              title: '',
              content: `We cannot validate the address. Do you want to use the entered address instead?`,
              confirmBtnText: 'Ok',
              cancelBtnText: 'Cancel',
            },
          })
          .afterClosed()
          .subscribe(async respo => {
            if(respo){
              this.confirmOrder(order);
            }else{
              console.log(order);
            }
          });
        this.ordered = false;
      },
    );
    this.loading$.next(false);
  }
  confirmOrder(payload: any) {
    this.orderFrameLoading = true;
    this.orderService.postOrder(payload).subscribe(
      (result: any) => {
        this.orderFrameLoading = false;
        if (result.success) {
          this.loading$.next(false);
          this._ngZone.run(() => this.router.navigateByUrl(`/order/orderconfirmation/${result.confirmationNumber}`));
        } else {
          this.displayOrderErrMsg();
        }
      },
      error => {
        this.orderFrameLoading = false;
        this.displayOrderErrMsg();
      },
    );
  }

  displayOrderErrMsg() {
    this.loading$.next(false);
    this.ordered = false;
    this.form.markAllAsTouched();
    const notificationOptions = {
      title: 'Sorry!',
      contentHtml: 'There was an issue with your order. Please contact customer service for assistance.',
      confirmBtnText: 'Close',
    };
    this.notificationService.error(notificationOptions);
  }
  isOrderability(frame:any){
    this.orderability = (!frame?.orderability ? '0' : frame?.orderability);
    if(this.orderability === '1'){
      this.sendFrameTo.patchValue('My Office');
      this.sendFrameTo.updateValueAndValidity();
    }else{
      this.sendFrameTo.patchValue('Lab');
      this.sendFrameTo.updateValueAndValidity();
    }
  }
  getRelatedFrames(frame) {
    this.frame = frame;
    if (!this.form) {
      this.form = this.createForm();
      this.showPatient();
      this.sendFrameTo.valueChanges.subscribe(value => {
        if (value === 'Lab') {
          this.rxOrderId.setValidators(this.rxIdVWPattern);
        } else {
          this.rxOrderId.setValidators(null);
        }
        this.rxOrderId.updateValueAndValidity();
      });

      this.displayBoard.valueChanges.subscribe(value => {
        if (value) {
          this.firstName.setValidators(null);
          this.firstName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.lastName.setValidators(null);
          this.lastName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
        } else {
          this.firstName.setValidators(Validators.required);
          this.firstName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.lastName.setValidators(Validators.required);
          this.lastName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
        }
        this.firstName.updateValueAndValidity();
        this.lastName.updateValueAndValidity();
      });

      this.laboratory.valueChanges.subscribe(value => {
        if (value !== 'primary') {
          this.manageCareLab.setValidators(Validators.required);
          this.manageCareLab.setValue('');
        } else {
          this.manageCareLab.setValidators(null);
        }
        this.manageCareLab.updateValueAndValidity();
      });

      this.provider.valueChanges.subscribe(value => {
        if (value === 'uhc') {
          this.firstName.setValidators(null);
          this.firstName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.lastName.setValidators(null);
          this.lastName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.firstName.setValue('HIDDEN');
          this.lastName.setValue('HIDDEN');
        } else {
          this.firstName.setValidators(Validators.required);
          this.firstName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.lastName.setValidators(Validators.required);
          this.lastName.setValidators(Validators.pattern('^[A-Za-z0-9 ]+$'));
          this.firstName.setValue('');
          this.lastName.setValue('');
        }
        this.firstName.updateValueAndValidity();
        this.lastName.updateValueAndValidity();
      });
      this.isOrderability(this.frame);
      this.frameOutOfStock(frame);
    }

    // set the selectedFrameUpc as the intial frame
    this.selectedFrameUpc = this.frame.upc;
    if (this.patientId) {
      this.store.dispatch({
        type: FramesActionTypes.LOAD_PATIENT_RELATED_FRAMES,
        payload: {
          upc: this.frame.upc,
          patientId: this.patientId,
        },
      });
    } else {
      this.store.dispatch({
        type: FramesActionTypes.LOAD_RELATED_FRAMES,
        payload: this.frame.upc,
      });
    }
  }

  getDropShip() {
    // if (this.laboratory.value === 'Required Manage Care Laboratory')
    //   this.userService.getDropship().subscribe(dropShip => {
    //     console.log(dropShip);
    //     this.manageCareLabList = dropShip;
    //   });
  }

  changeFrame(frame) {
    this.selectedFrameUpc = frame.upc;
    this.frame = frame;
    this.eyeSize.setValue(this.frame.eyeSize);
    this.form.patchValue({
      sendFrameTo:
        this.frame.inStock === true ||
        (this.frame.exceptionType !== 'OUT_OF_STOCK' && this.frame.exceptionType !== 'SHORT_SHIP')
          ? 'Lab'
          : 'My Office',
    });

    this.check360(frame.upc);

    // this.orderService.getRBAMessage(this.frame.upc).subscribe(message => {
    //   this.RBAMessage = message;
    // });
  }

  isOrderFrameDisabled() {
    this.isMeta = this.isMetaFrame();
    this.isNuance = this.isNuanceFrame();
    return this.form.invalid || this.manageCareLabList.length === 0 || this.ordered || !this.isMeta || !this.isNuance;
  }

  isMetaFrame() {
    let frameMeta = this.frame?.isMetaFrame;
    let dropshipMeta = this.manageCareLabList.primary?.isMetaEnabled;
    let sendToLab = this.sendFrameTo.value == 'Lab';

    if (this.form.value.laboratory !== 'primary') {
      dropshipMeta = this.form.value.manageCareLab?.isMetaEnabled;
    }
    if (frameMeta && sendToLab) {
      if (frameMeta && dropshipMeta) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isNuanceFrame() {
    let frameNuance = this.frame?.isNuanceFrame;
    let dropshipNuance = this.manageCareLabList.primary?.isNuanceEnabled;
    let sendToLab = this.sendFrameTo.value == 'Lab';

    if (this.form.value.laboratory !== 'primary') {
      dropshipNuance = this.form.value.manageCareLab?.isNuanceEnabled;
    }
    if (frameNuance && sendToLab) {
      if (frameNuance && dropshipNuance) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  selectEyeSize() {
    this.relatedFrames$.subscribe(frames => {
      frames.forEach(element => {
        if (element.eyeSize === this.eyeSize.value) {
          this.changeFrame(element);
        }
      });
    });
  }

  open360FrameModal(upc): void {
    let dialogRef = this.dialog.open(ImageModalComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
      data: {
        upc: upc,
      },
    });
  }

  check360(upc) {
    let img = new Image();
    img.src = environment.image360Url + upc + '_1.jpg';
    img.onload = () => {
      this.is360Available = true;
    };
    this.is360Available = false;
  }

  onChange(event): void {
    this.changeRxOrderIdPattern();
  }

  setVBA() {
    this.isVBA = !this.isVBA;
    this.changeRxOrderIdPattern();
  }

  changeRxOrderIdPattern() {
    switch (this.provider.value) {
      case 'eyemed':
      case 'privatepay':
      case 'versant': {
        this.rxOrderId.setValidators(this.rxIdVWPattern.concat(Validators.required));
        break;
      }
      case 'vsp': {
        this.rxOrderId.setValidators(this.rxIdVSPPattern.concat(Validators.required));
        break;
      }
      case 'uhc': {
        this.rxOrderId.setValidators(this.rxIdUHCPattern.concat(Validators.required));
        break;
      }
      case 'vba': {
        this.rxOrderId.setValidators(this.rxIdVBAPattern.concat(Validators.required));
        break;
      }
    }
    /*     if (this.isVBA) {
      this.form
        .get('rxOrderId')
        .setValidators(this.rxIdVBAPattern.concat(Validators.required));
    } else {
      this.form
        .get('rxOrderId')
        .setValidators(this.rxIdPattern.concat(Validators.required));
    } */
    this.form.get('rxOrderId').updateValueAndValidity();
  }

  addFrameToCart() {
    this.store.dispatch({
      type: FramesCartActionTypes.ADD_FRAMES_TO_CART,
      payload: {
        brandName: this.frame.brandName,
        smallImageUrl: this.frame.smallImageUrl,
        largeImageUrl: this.frame.largeImageUrl,
        styleName: this.frame.styleName,
        colorDescription: this.frame.colorDescription,
        eyeSize: this.frame.eyeSize,
        temple: this.frame.temple,
        upc: this.frame.upc,
        fpc: this.frame.fpc,
      },
    });

    this.dialog.open(AddToCartNotificationsComponent, {
      maxWidth: '400px',
      data: {
        patientId: this.patientId,
      },
    });
  }

  ngOnDestroy() {
    this.store.dispatch({
      type: FramesActionTypes.CLEAR_RELATED_FRAMES,
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
